module.exports = __webpack_public_path__ + "img/ActivityProfileEdit.e67813ea.svg";